import { makeStyles } from "@material-ui/core";
import { Paper, Tab, Tabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { misi, visi } from "../../assets";

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
    backgroundColor: "#0A8C4A",
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(18),
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
      color: "#000",
      fontWeight: 500,
    },
  })
);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "200px",
    // backgroundColor: theme.palette.background.paper,
  },
  tab: {
    width: "200px",
    color: "#000",
    "&.Mui-selected": {
      backgroundColor: "#1765C5",
      color: "#fff !important",
      transition: "background-color .5s ease-in-out",
      borderRadius: "200px",
      fontWeight: 700,
    },
  },
  indicator: {
    display: "none", // Hide the default indicator
  },
}));

export default function TabCompany() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="tab-vm d-flex justify-content-evenly align-items-center gap-3">
      <Paper
        className="tab-content bg-vm d-flex justify-content-between align-items-center gap-3 p-4"
        sx={{
          width: "636px",
          height: "240px",
          backgroundColor: "#0A8C4A",
          borderRadius: "15px",
          boxShadow: "10px 10px rgba(0, 0, 0)",
        }}
      >
        <img src={misi} alt="Visi Misi Mostrans" width={120} />
        <div>
          <h3 className="text-warning-hm">Visi Kami</h3>
          <p className="text-white">
            Menjadi platform solusi total logistik kesehatan terdepan.
          </p>
        </div>
      </Paper>
      <Paper
        className="tab-content bg-vm d-flex justify-content-between align-items-center gap-3 p-4"
        sx={{
          width: "635px",
          height: "240px",
          backgroundColor: "#0A8C4A",
          borderRadius: "15px",
          boxShadow: "10px 10px rgba(0, 0, 0)",
        }}
      >
        <img src={visi} alt="Visi Misi Mostrans" width={120} />
        <div>
          <h3 className="text-warning-hm">Misi Kami</h3>
          <p className="text-white">
            Membangun ekosistem logistik berbasis digital untuk Indonesia yang
            lebih sehat.
          </p>
        </div>
      </Paper>
    </div>
  );
}
